module.exports = __webpack_public_path__ + "static/img/t1-4-1.8d49fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-4-1.png
// module id = 1+7N
// module chunks = 1